
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-portal/about-us",
      function () {
        return require("private-next-pages/community-portal/about-us.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-portal/about-us"])
      });
    }
  